/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Component, OnInit, OnDestroy } from '@angular/core';
import { AddFittingComponent } from '../add-fitting-size/add-fitting.component';
import { DialogBoxComponent } from '../../shared/dialog-box/dialog-box.component';
import { UserHandlerService } from '../../sharedServices/user-handler.service';
import { GenericTableData } from '../../sharedServices/generic-table-data.service';
import { FittingSizeDataService } from '../../sharedServices/fittingSize-data.service';
import { FittingSizeManagementService } from '../../sharedServices/fitting-size-management.service';
import { AuthentificationService } from '../../sharedServices/authentification.service';
import { LoaderService } from '../../sharedServices/loader.service';
import { ActionPageEnumDto, FittingDto, ActionTypeEnumDto } from 'api/models';
import { FittingsManagementService } from 'api/services';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'app-fitting-state-management',
  templateUrl: './fitting-state-management.component.html',
})
export class FittingStateManagementComponent extends AddFittingComponent
  implements OnInit, OnDestroy {

  ngOnInit() {
    this.actionPage = ActionPageEnumDto.Continue;
    this.resetExistingFittingSizeDataTable();
    this.setTableHeaders();
    this.getFittingsData();
  }

  constructor(
    public dialog: MatDialog,
    public userHandlerService: UserHandlerService,
    public fittingsManagementService: FittingsManagementService,
    public genericTableDataService: GenericTableData,
    public fittingSizeDataService: FittingSizeDataService,
    public fittingSizeManagementService: FittingSizeManagementService,
    public authentificationService: AuthentificationService,
    public loaderService: LoaderService
  ) {
    super(dialog, userHandlerService, fittingsManagementService, genericTableDataService,
      fittingSizeDataService, fittingSizeManagementService, authentificationService, loaderService);
  }

  onSendForApproveActionClick(element: FittingDto) {
    const dialogRef = this.dialog.open(DialogBoxComponent, {
      data: {
        title: 'Send for approve',
        comment: '',
        message: 'Do you want to send for approve this fitting?',
        addComment: true
      }
    });
    this.handleActionButton(dialogRef, element, 'SendForApprove');
  }

  getExistingFittingSizes(fitting: FittingDto) {

    super.getExistingFittingSizes(fitting, true);

  }

  onUndoActionClick(element: FittingDto) {
    const dialogRef = this.dialog.open(DialogBoxComponent, {
      data: {
        title: 'Undo fitting',
        comment: '',
        message: 'Do you want to undo this fitting?',
        addComment: true
      }
    });
    this.handleActionButton(dialogRef, element, 'Undo');
  }

  handleActionButton(
    dialogRef: MatDialogRef<DialogBoxComponent, any>,
    element,
    actionType: string
  ) {
    const subscribeOk = dialogRef.componentInstance.okClickEvent.subscribe(
      () => {
        if (
          dialogRef.componentInstance.data.addComment &&
          dialogRef.componentInstance.data.comment !== '' &&
          dialogRef.componentInstance.data.comment !== undefined
        ) {
          switch (actionType) {
            case 'SendForApprove':
              this.onSendForApproveAction(
                element,
                dialogRef.componentInstance.data.comment
              );
              break;
            case 'Undo':
              this.onUndoAction(
                element,
                dialogRef.componentInstance.data.comment
              );
              break;
          }
        } else {
          this.fittingSizeManagementService.openSnackBar(
            'Add a comment before sending or undoing a fitting'
          );
        }
      }
    );
    dialogRef.afterClosed().subscribe(() => {
      subscribeOk.unsubscribe();
    });
  }

  onSendForApproveAction(element: FittingDto, comment: string) {
    this.loaderService.display(true);
    let nextActionType: ActionTypeEnumDto;
    switch (element.statusID) {
      case ActionTypeEnumDto.ChangeToContinue:
        nextActionType = ActionTypeEnumDto.RequestToContinueFittingSendForApproval;
        break;
      case ActionTypeEnumDto.ChangeToDiscontinue:
        nextActionType = ActionTypeEnumDto.RequestToDiscontinueFittingSendForApproval;
        break;
    }

    this.fittingsManagementService.updateApprovalStatus({
      userId: this.userHandlerService.getCurrentUserId(),
      bdToolId: element.bdToolID,
      actionTypeEnumDto: nextActionType,
      fittingEntryId: element.fittingEntryID,
      comment
    }).subscribe(() => {
      this.getFittingsData();
      this.fittingSizeManagementService.openSnackBar(
        'Sent for aproval'
      );
    });
  }

  onUndoAction(element: FittingDto, comment: string) {
    this.loaderService.display(true);
    let nextActionType: ActionTypeEnumDto;
    switch (element.statusID) {
      case ActionTypeEnumDto.ChangeToContinue:
        nextActionType = ActionTypeEnumDto.UndoRequestToContinue;
        break;
      case ActionTypeEnumDto.ChangeToDiscontinue:
        nextActionType = ActionTypeEnumDto.UndoRequestToDiscontinue;
        break;
    }
    this.fittingsManagementService.undoFittingRequest({
      userId: this.userHandlerService.getCurrentUserId(),
      bdToolId: element.bdToolID,
      actionTypeEnumDto: nextActionType,
      fittingEntryId: element.fittingEntryID,
      comment
    }).subscribe(() => {
      this.getFittingsData();
      this.fittingSizeManagementService.openSnackBar(
        'Fitting has been rejected succesfully'
      );
    });
  }
}
